import css from 'styled-jsx/css';

const styles = css.global`#energia-solar-parceiros {
  background-color: #f8fcf8;
  padding-top: 72px;
  padding-bottom: 78px;
}

#energia-solar-parceiros .img-parceiros {
  margin: 0 auto;
  display: block;
}

#energia-solar-parceiros .energia-solar-parceiros-titulo {
  color: #c00;

  font-family: 'SantanderHeadline';
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px; /* 150% */

  margin-bottom: 8px;
  max-width: 240px;
}

#energia-solar-parceiros .energia-solar-parceiros-texto {
  color: #444;

  /* 768/Body */
  font-family: 'SantanderText';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  max-width: 288px;
  margin-bottom: 24px;
}

#energia-solar-parceiros .dropdown {
  margin-bottom: 32px;
  background-color: #fff;
}

#energia-solar-parceiros .parceiros-results {
  overflow: hidden;
}

#energia-solar-parceiros .parceiros-bullet {
  color: #222;
  text-align: center;
  font-family: 'SantanderText';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#energia-solar-parceiros .embla__next {
  background-image: url(assets/energia-solar/parceiros/ic-arrow-right.svg);
  background-size: 10px 20px;
}

#energia-solar-parceiros .embla__prev {
  background-image: url(assets/energia-solar/parceiros/ic-arrow-left.svg);
  background-size: 10px 20px;
}

#energia-solar-parceiros .parceiros {
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #fff;

  display: flex;
  min-height: 208px;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  box-sizing: border-box;
  margin-bottom: 16px;
}

#energia-solar-parceiros .mb-0 {
  margin-bottom: 0;
}

#energia-solar-parceiros .home-pagination {
  max-width: 140px;
  box-sizing: border-box;
  margin-top: 42px;
}

#energia-solar-parceiros .parceiros-titulo {
  color: #000;

  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 600;
  line-height: 150%; /* 27px */
}

#energia-solar-parceiros .parceiros-endereco {
  color: #000;

  font-family: 'SantanderText';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

#energia-solar-parceiros .parceiros-saiba-mais {
  color: #c00;

  /* 768/CTA */
  font-family: 'SantanderText';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;

  margin-top: auto;
}

#energia-solar-parceiros .parceiro-slide {
  transition: padding-left linear 750ms;
}

#energia-solar-parceiros .parceiro-slide.extra-space {
  transition: padding-left linear 100ms;
  padding-left: 16px;
}

#energia-solar-parceiros .energia-solar-disclaimer {
    font-family: "SantanderMicroText";
    font-size: 13px;
    font-style: normal;
    font-weight: 200;
    line-height: 20px;
    margin-bottom: 20px;
}

@media (max-width: 991px) {
  #energia-solar-parceiros .desk {
    display: none !important;
  }
}

@media (min-width: 992px) {
  #energia-solar-parceiros .mobile {
    display: none !important;
  }

  #energia-solar-parceiros {
    padding-top: 64px;
    padding-bottom: 92px;
  }

  #energia-solar-parceiros .parceiros-container {
    position: relative;
  }

  #energia-solar-parceiros .img-parceiros {
    margin: 0;
    display: block;
    z-index: 1;
    position: absolute;
    top: 0;
    right: 0;
  }

  #energia-solar-parceiros .energia-solar-parceiros-titulo {
    color: #c00;
    /* 768/Heading2 */
    font-family: 'SantanderHeadline';
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 42px; /* 131.25% */

    max-width: 600px;
    margin-bottom: 16px;
  }

  #energia-solar-parceiros .energia-solar-parceiros-texto {
    color: #444;

    /* 768/Body */
    font-family: 'SantanderText';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 155.556% */
    margin-bottom: 24px;
    max-width: unset;
  }

  #energia-solar-parceiros .dropdown {
    max-width: 420px;
  }

  #energia-solar-parceiros .btn-buscar-parceiros {
    max-width: 334px;
    width: 100%;
  }

  #energia-solar-parceiros .btn-buscar-parceiros.hidden {
    display: none !important;
  }

  #energia-solar-parceiros .energia-solar-disclaimer {
    margin-top: 70px;
  }

  #energia-solar-parceiros .parceiro-slide {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-items: flex-start;
    gap: 16px;
    padding: 0;
  }

  #energia-solar-parceiros .parceiro-slide.fix-line {
    padding-left: 1px;
  }

  #energia-solar-parceiros .parceiros {
    flex: 1;
    max-width: 380px;
    margin-bottom: 0;
  }

  #energia-solar-parceiros .carousel-skeleton {
    width: 100%;
    display: block;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 100px;
    height: 316px;
  }

  #energia-solar-parceiros .home-pagination {
    margin-top: 60px;
    margin-bottom: 0;
  }
}
`;

export default styles;